import { getEnvironment } from "../Config/utils/enviroment";
import { ddLogs } from "./ddlogs";

type LogLevel = "debug" | "info" | "warn" | "error";

const environment = getEnvironment();
const isProd = environment.startsWith("prod");

const shouldLog = (level: LogLevel) => {
  if (isProd) {
    return level === "error";
  }
  return true;
};

const safeStringify = (value: unknown) => {
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

const logToConsole = (level: LogLevel, message: string, payload?: unknown) => {
  const consolePayload =
    payload === undefined ? undefined : safeStringify(payload);
  switch (level) {
    case "error":
      // eslint-disable-next-line no-console
      console.error(message, consolePayload);
      break;
    case "warn":
      // eslint-disable-next-line no-console
      console.warn(message, consolePayload);
      break;
    case "info":
    case "debug":
    default:
      // eslint-disable-next-line no-console
      console.log(message, consolePayload);
      break;
  }
};

const logToDatadog = (level: LogLevel, message: string, payload?: unknown) => {
  const suffix =
    payload === undefined ? "" : ` | payload=${safeStringify(payload)}`;
  const formattedMessage = `${message}${suffix}`;
  switch (level) {
    case "error":
      ddLogs.error(formattedMessage);
      break;
    case "warn":
      ddLogs.warn(formattedMessage);
      break;
    case "info":
      ddLogs.info(formattedMessage);
      break;
    case "debug":
    default:
      ddLogs.debug(formattedMessage);
      break;
  }
};

const log = (level: LogLevel, message: string, payload?: unknown) => {
  if (!shouldLog(level)) return;
  logToConsole(level, message, payload);
  logToDatadog(level, message, payload);
};

export const logger = {
  debug: (message: string, payload?: unknown) =>
    log("debug", message, payload),
  info: (message: string, payload?: unknown) => log("info", message, payload),
  warn: (message: string, payload?: unknown) => log("warn", message, payload),
  error: (message: string, payload?: unknown) => log("error", message, payload),
  analytics: (eventName: string, payload?: Record<string, unknown>) =>
    log("info", `[analytics] ${eventName}`, payload),
};

